import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "18",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("rect", {
  width: "24",
  height: "18",
  fill: "#9CB3BA",
  rx: "2"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#EEF3F5",
  d: "M15.749 11.673h-1.656c-.259 1.094-1.003 1.853-2.203 1.853-.639 0-1.216-.243-1.596-.653-.532-.577-.653-1.2-.653-3.373s.121-2.796.653-3.373c.38-.41.957-.653 1.595-.653 1.2 0 1.93.76 2.188 1.853h1.672C15.369 5.17 13.879 4 11.889 4c-1.124 0-2.096.41-2.84 1.155C7.984 6.218 8 7.419 8 9.5s-.015 3.282 1.048 4.345C9.793 14.59 10.765 15 11.89 15c1.96 0 3.494-1.17 3.859-3.327"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }